import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../../services/api';
import './Admin.css';

const MasterData = () => {
  const [activeTab, setActiveTab] = useState('skills');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({ name: '', code: '' });

  const tabs = [
    // { id: 'skills', label: 'Skills', icon: '💼' },
    { id: 'job-types', label: 'Job Types', icon: '📋' },
    { id: 'industry-types', label: 'Industries', icon: '🏢' },
    { id: 'shift-types', label: 'Shift Types', icon: '⏰' },
    { id: 'educations', label: 'Education', icon: '🎓' },
    { id: 'benefits', label: 'Benefits', icon: '🎁' },
  ];

  useEffect(() => {
    fetchData();
  }, [activeTab]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/master/${activeTab}`);
      setData(response.data || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to fetch data');
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingItem(null);
    setFormData({ name: '', code: '' });
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({ name: item.name, code: item.code || '' });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingItem) {
        await api.put(`/master/${activeTab}/${editingItem._id}`, formData);
        toast.success('Updated successfully');
      } else {
        await api.post(`/master/${activeTab}`, formData);
        toast.success('Added successfully');
      }
      setShowModal(false);
      fetchData();
    } catch (error) {
      console.error('Error saving data:', error);
      toast.error('Failed to save');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this item?')) {
      return;
    }

    try {
      await api.delete(`/master/${activeTab}/${id}`);
      toast.success('Deleted successfully');
      fetchData();
    } catch (error) {
      console.error('Error deleting:', error);
      toast.error('Failed to delete');
    }
  };

  return (
    <div className="admin-page">
      <div className="page-header">
        <div>
          <h1>Master Data Management</h1>
          <p>Manage skills, job types, industries, and more</p>
        </div>
        <button className="btn btn-primary" onClick={handleAdd}>
          + Add New
        </button>
      </div>

      {/* Tabs */}
      <div className="master-data-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {/* <span className="tab-icon">{tab.icon}</span> */}
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Data Table */}
      {loading ? (
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    No data found. Click "Add New" to create one.
                  </td>
                </tr>
              ) : (
                data.map((item) => (
                  <tr key={item._id}>
                    <td>{item.name}</td>
                    <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn btn-sm btn-outline"
                          onClick={() => handleEdit(item)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(item._id)}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content edit_modal" style={{padding:'16px 25px'}} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header" style={{borderBottom:'none', marginBottom:'0px',}}>
              <h2>{editingItem ? 'Edit' : 'Add New'} {tabs.find(t => t.id === activeTab)?.label}</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>
                ×
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingItem ? 'Update' : 'Add'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default MasterData;
